<template>
  <div>
    <jd-form
      :form-info="myFormInfo"
      @search="search"
      :emitReset="true"
      ref="searchFormRef"
      @reset="(val) => search(val, 'reset')">
    </jd-form>

    <div class="flex-between mt16 mb12">
      <div>
        <jd-button type="blueLine" @click="addCrowd" :disabled="tableData.length <= 0"
          >按查询结果生成人群</jd-button
        >
        <jd-button @click="isShowStatic = true">问卷统计</jd-button>
        <jd-button
          :disabled="!selectedRows.length"
          @click="batchAudit"
          >批量审核</jd-button
        >
      </div>
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>
    <jd-table
      :loading="loading"
      :tableData="tableData"
      :pageInfo="{
        pageNum: formList.current,
        pageSize: formList.size,
        total: total,
      }"
      row-key="recordId"
      ref="tableRef"
      :selection="selection"
      :selectable="selectable"
      @handleSelectionChange="handleSelectionChange"
      @handlePage="handlePage">
      <el-table-column prop="memberNick" label="用户昵称" min-width="120">      </el-table-column>      <el-table-column prop="sellerLinkName" label="投放渠道" width="150">      </el-table-column>
      <el-table-column
        :prop="chaosParams"
        :label="`用户${grayText}`"
        width="150"></el-table-column>
      <el-table-column prop="isWin" label="是否中奖" min-width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.isWin == 1">是</span>
          <span v-else-if="scope.row.isWin == 0">否</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="processStatus" label="审核状态">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.processStatus == '-1'"><jd-status :status="2">待提交</jd-status></span> -->
          <span v-if="scope.row.processStatus == 0"><jd-status :status="2">待审核</jd-status></span>
          <span v-else-if="scope.row.processStatus == 1"><jd-status :status="0">通过</jd-status></span>
          <span v-else-if="scope.row.processStatus == 2"><jd-status :status="3">驳回</jd-status></span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="processRemark" label="审核备注">
        <template slot-scope="scope">
          <span>{{ scope.row.processRemark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="submitTime" label="提交时间" min-width="180">
      </el-table-column>
      <!-- 动态列 -->
      <el-table-column
        v-for="question in dynamicColumns"
        :key="question"
        :label="question"
        width="220">
        <template #default="scope">
          <div
            @click="showImage(scope.row.answerVOList, question, $event)"
            v-html="getAnswer(scope.row.answerVOList, question)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
         <jd-button type="blueText" :disabled="scope.row.processStatus != 0" @click="handleAudit(scope.row)">审核</jd-button>
        </template>
      </el-table-column>
    </jd-table>

    <div class="image-preview-container" v-if="showImageDialog">
      <div class="image-wrapper">
        <img :src="currentImageUrl" alt="预览图片" class="preview-image" />
        <div class="close-button" @click="showImageDialog = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>

    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="formList"
      :activityType="47"
      :source="28"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose" />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"></generate>

    <quesStatistics
      :show.sync="isShowStatic"
      :activityId="activityId"></quesStatistics>
      <!-- 审核弹窗 -->
      <auditInfo
        v-model="isShowAudit"
        :isBatch="isBatch"
        :rowData="auditRowData"
        :activityId="activityId"
        :actType="47"
        :proccessSelection="selectedRows"
        @update="updateData"
      />
  </div>
</template>

<script>
import {
  getQuestionnaireRecord,
  exportQuestionnaireRecord,
} from "@/api/jhk/questionnaire.js";
import crowdDialog from "../crowd-Dialog.vue";
import statisticsData from "@/mixin/activity_statistics_new.js";
import quesStatistics from "./_components/questionnaireStatistics.vue";
import auditInfo from "./xhsRecord/auditInfo.vue";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
    quesStatistics,
    auditInfo
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
    channelList: {
      type: Array,
      default: () => [],
    },
    sellerLinkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableOpenAll: false,
      tableData: [],
      total: 0,
      loading: false,
      dynamicColumns: [], // 题目
      showImageDialog: false,
      currentImageUrl: "",
      myFormInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "提交时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [], // 初始化为空数组
        },
        {
          label: "是否中奖：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "审核状态：",
          prop: "processStatus",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "通过", value: 1 },
            { label: "驳回", value: 2 },
            { label: "待审核", value: 0 },
            // { label: "待提交", value: -1 },
          ],
        },
      ],
      formList: {
        size: 10,
        current: 1,
        activityId: this.activityId,
      },
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗

      isShowStatic: false,
      auditRowData: {},
      isShowAudit: false,//审核弹窗
      isBatch: false,//是否批量审核
      selectedRows: [],//批量审核选中的行
      selection: true
    };
  },
  computed: {
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'pin'
    },
  },
  mounted() {
    this.updateSellerLinkOptions(); // 初始化时更新选项
    this.searchMethods();
  },
  watch: {
    // 监听sellerLinkList变化并更新表单选项
    sellerLinkList: {
      handler() {
        this.updateSellerLinkOptions();
      },
      deep: true
    },
    searchGrayId: {
      handler(newVal, oldVal) {
        this.myFormInfo.forEach((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      immediate: true,
    }
  },
  methods: {
    updateData() {
      this.selectedRows = [];
      this.$refs.tableRef.handleClearSelection();
      this.searchMethods();
    },
    batchAudit() {
      this.isShowAudit = true;
      this.isBatch = true;
    },
    selectable(row, index) {
      if (row.processStatus == 0) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val&&val.length?val.map((item)=>{
        return {
          ...item,
          id: item.recordId
        }
      }):[];
    },
    // 审核
    handleAudit(row) {
      this.isShowAudit = true;
      this.isBatch = false;
      this.auditRowData = {...row,id: row.recordId};
    },
    addCrowd() {
      // 如果版本为京获客旗舰版需要校验用户时候有该按钮权限
      if (this.softType == 1 && !this.$store.getters.isJhkPlatformSeller) {
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      this.hasDefaultValue = true;
      this.defaultValueText = "调查问卷-问卷调查记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    exportAll() {
      this.openRemarkDialog = true;
    },
    confirmExport(exportRemark = "") {
      let obj = this.$refs.searchFormRef.getSearchForm();
      let params = {
        ...obj,
        activityId: this.activityId,
        current: 1,
        size: 9999999,
        exportRemark,
      };
      this.formLoading = true;
      exportQuestionnaireRecord(params).then((res) => {
        this.formLoading = false;
      });
    },
    search(params, type) {
      this.formList = {
        size: 10,
        current: 1,
        ...params,
        memberNick: params.memberNick || "",
        // pin: params.pin || "",
        [this.searchGrayId]: params[this.searchGrayId] || "",
        activityId: this.activityId,
      };
      if (type == "reset") {
        this.formList = {
          size: 10,
          current: 1,
          activityId: this.activityId,
        };
        this.$refs.searchFormRef.reData();
      }
      this.searchMethods();
    },
    showImage(answerList, question, event) {
      const answer = answerList.find((item) => item.type === question);
      // 检查是否有内容
      if (!answer || !answer.content) {
        return;
      }
      // 找到被点击的元素
      let target = event.target;

      // 如果点击的是放大镜图标，找到对应的图片
      if (target.className === "el-icon-zoom-in") {
        target = target.closest(".image-container").querySelector("img");
      }
      // 确保点击的是图片元素或其容器
      if (target.tagName === "IMG") {
        // 从自定义属性中获取图片URL
        const imageUrl = target.getAttribute("data-url");

        if (imageUrl) {
          console.log("显示图片", imageUrl);
          this.currentImageUrl = imageUrl;
          this.showImageDialog = true;
        }
      } else if (target.classList.contains("image-overlay")) {
        // 如果点击的是遮罩层，找到对应的图片
        const img = target.parentElement.querySelector("img");
        if (img) {
          const imageUrl = img.getAttribute("data-url");
          if (imageUrl) {
            console.log("显示图片", imageUrl);
            this.currentImageUrl = imageUrl;
            this.showImageDialog = true;
          }
        }
      }
    },
    // 获取答案
    getAnswer(answerList, question) {
      const answer = answerList.find((item) => item.type === question);
      if (answer) {
        // 如果是图片上传题，返回图片标签
        if (question.includes("图片上传题") && answer.content) {
          // 使用逗号分隔多个图片地址
          const imageUrls = answer.content.split(",").map((url) => url.trim());
          // 生成图片标签
          const imagesHtml = imageUrls
            .map((url, index) => {
              return `
              <div class="image-container" style="display: inline-block; position: relative; margin-right: 10px;">
                <img src="${url}" alt="图片" data-index="${index}" data-url="${url}" style="width: 50px; height: 50px; cursor:pointer;">
                <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                  <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
                </div>
              </div>
            `;
            })
            .join("");
          return imagesHtml;
        } else if (question.includes("图片多选题") && answer.content) {
          // 使用逗号分隔多个图片地址
          const imageUrls = answer.content.split(",").map((url) => url.trim());
          // 生成图片标签
          const imagesHtml = imageUrls
            .map((url, index) => {
              return `
              <div class="image-container" style="display: inline-block; position: relative; margin-right: 10px;">
                <img src="${url}" alt="图片" data-index="${index}" data-url="${url}" style="width: 50px; height: 50px; cursor:pointer;">
                <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                  <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
                </div>
              </div>
            `;
            })
            .join("");
          return imagesHtml;
        } else if (question.includes("图片选择题") && answer.content) {
          // 如果是图片选择题，返回单个图片标签
          return `
            <div class="image-container" style="display: inline-block; position: relative;">
              <img src="${answer.content}" alt="图片" data-url="${answer.content}" style="width: 50px; height: 50px; cursor:pointer;">
              <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
              </div>
            </div>
          `;
        } else if (question.includes("矩阵题") && answer.content) {
          let contentArr = answer.content
            .split(",")
            .map((content) => content.trim());
          const contentHtml = contentArr
            .map((content, index) => {
              return `
              <div style="display: block; position: relative;">
                <div>${content}</div>
              </div>
            `;
            })
            .join("");
          return contentHtml;
        } else {
          // 其他类型返回内容
          return answer.content || "-";
        }
      }
      return "-";
    },

    handleCurrent(val) {
      this.formList.current = val;
      this.searchMethods();
    },

    handleSize(val) {
      this.formList.size = val;
      this.formList.current = 1;
      this.searchMethods();
    },
    handlePage(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.searchMethods();
    },
    // 更新投放渠道下拉选项
    updateSellerLinkOptions() {
      const sellerLinkField = this.myFormInfo.find(item => item.prop === 'sellerLinkId');
      if (sellerLinkField && this.sellerLinkList && this.sellerLinkList.length > 0) {
        sellerLinkField.options = this.sellerLinkList.map(item => ({
          label: item.sellerLinkName,
          value: item.id
        }));
      }
    },
    
    searchMethods() {
      this.loading = true;
      getQuestionnaireRecord(this.formList)
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.records;
            this.total = Number(res.data.total);
            // 提取所有可能的题目类型
            const allQuestions = new Set();
            this.tableData.forEach((item) => {
              item.answerVOList.forEach((answer) => {
                allQuestions.add(answer.type);
              });
            });
            this.dynamicColumns = Array.from(allQuestions);
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.image-preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 添加渐显渐隐效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.image-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: zoom-in 0.3s ease;
}

@keyframes zoom-in {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.preview-image {
  max-width: 80%;
  max-height: 80vh;
  object-fit: contain;
}

.close-button {
  position: absolute;
  bottom: -50px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.close-button i {
  font-size: 20px;
  color: #333;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 1);
}
</style>
